import actionTypes from '../constants/action-types';

const setTldCollection = (tldCollection) => ({
  type: actionTypes.SET_TLD_COLLECTION,
  payload: {
    tldCollection,
  },
});

export default setTldCollection;
